import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Col,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
} from "reactstrap";
import InputMask from "react-input-mask";
import { NumericFormat } from "react-number-format";
import LoadingModal from "components/Common/ModalSpinner";
import Swal from "sweetalert2";

const NovaConsultaModal = ({ isOpen, toggle, cliente }) => {
  const [areas, setAreas] = useState([]);
  const [subservicos, setSubservicos] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");
  const [selectedSubservico, setSelectedSubservico] = useState("");
  const [tipoConsulta, setTiposConsulta] = useState("");
  const [data, setData] = useState("");
  const [horario, setHorario] = useState("");
  const [observacao, setObservacao] = useState("");
  const [tipo, setTipo] = useState("");
  const [valor, setValor] = useState("0");
  const [loading, setLoading] = useState(false);
  const [text, setText] = useState("");

  useEffect(() => {
    if (isOpen) {
      fetchAreas();
      fetchTiposConsulta();
    }
  }, [isOpen]);

  useEffect(() => {
    if (selectedArea) {
      fetchSubservicos(selectedArea);
    }
  }, [selectedArea]);

  const fetchAreas = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API}/areas`);
      const areas = await response.json();
      setAreas(areas);
    } catch (error) {
      console.error("Erro ao buscar áreas:", error);
    }
  };

  const fetchSubservicos = async (areaId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API}/subservicos/${areaId}`
      );
      const subservicos = await response.json();
      setSubservicos(subservicos);
    } catch (error) {
      console.error("Erro ao buscar subserviços:", error);
    }
  };

  const fetchTiposConsulta = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API}/tipoConsulta`);
      const tiposConsulta = await response.json();
      setTiposConsulta(tiposConsulta);
    } catch (error) {
      console.error("Erro ao buscar tipos de consulta:", error);
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    setText("Aguarde, marcando consulta...");

    const authUser = JSON.parse(localStorage.getItem("authUser"));

    console.log({ authUser });

    if (!authUser) {
      setLoading(false);
      return;
    }

    const id_medico = authUser.id;

    let valoFormatado = valor ? valor : "0";
    const consulta = {
      clienteId: cliente.id_cliente,
      areaId: selectedArea,
      subservicoId: selectedSubservico,
      data,
      horario,
      observacao,
      tipo,
      valor: valoFormatado,
      id_medico,
    };

    console.log({ consulta });

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API}/cadastrarNovaConsulta`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(consulta),
        }
      ).then((response) => {
        if (response) {
          console.log(response);
          return response.json();
        }
      });

      if (response) {
        const id_consulta = response?.novaConsulta.id_consulta;
        const url_consulta = `https://olismulher.com/remarcacao/${id_consulta}?i=${id_medico}`;

        setLoading(false);

        Swal.fire({
          title: "Consulta marcada com sucesso!",
          text: "Deseja abrir o link?",
          icon: "success",
          showCancelButton: true,
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
        }).then((result) => {
          if (result.isConfirmed) {
            window.open(url_consulta, "_blank");
            toggle();
          }
        });
      }

      // //toggle();
    } catch (error) {
      console.error("Erro ao marcar consulta:", error);
    }
  };

  return (
    <Modal size="xl" isOpen={isOpen} toggle={toggle}>
      <LoadingModal isOpen={loading} text={text} />

      <ModalHeader toggle={toggle}>
        Marcar Consulta - {cliente.nome}
      </ModalHeader>
      <ModalBody>
        <Form>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="area">Área</Label>
                <Input
                  type="select"
                  name="area"
                  id="area"
                  value={selectedArea}
                  onChange={(e) => setSelectedArea(e.target.value)}
                >
                  <option value="">Selecione a área</option>
                  {areas.map((area) => (
                    <option key={area.AreaID} value={area.AreaID}>
                      {area.Nome}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="subservico">Subserviço</Label>
                <Input
                  type="select"
                  name="subservico"
                  id="subservico"
                  value={selectedSubservico}
                  onChange={(e) => setSelectedSubservico(e.target.value)}
                  disabled={!selectedArea}
                >
                  <option value="">Selecione o subserviço</option>
                  {subservicos.map((subservico) => (
                    <option
                      key={subservico.SubservicoID}
                      value={subservico.SubservicoID}
                    >
                      {subservico.Nome}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="data">Data (OPCIONAL)</Label>
                <Input
                  type="date"
                  name="data"
                  id="data"
                  value={data}
                  onChange={(e) => setData(e.target.value)}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="horario">Horário (OPCIONAL)</Label>
                <InputMask
                  mask="99:99"
                  value={horario}
                  onChange={(e) => setHorario(e.target.value)}
                >
                  {(inputProps) => (
                    <Input
                      {...inputProps}
                      type="text"
                      name="horario"
                      id="horario"
                    />
                  )}
                </InputMask>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="observacao">Observação</Label>
                <Input
                  type="textarea"
                  name="observacao"
                  id="observacao"
                  value={observacao}
                  onChange={(e) => setObservacao(e.target.value)}
                />
              </FormGroup>
            </Col>

            {tipoConsulta && (
              <Col md={6}>
                <FormGroup>
                  <Label for="tipo">Tipo</Label>
                  <Input
                    type="select"
                    name="tipo"
                    id="tipo"
                    value={tipo}
                    onChange={(e) => setTipo(e.target.value)}
                  >
                    <option value="">Selecione o tipo</option>

                    {tipoConsulta.map((tipoConsulta) => (
                      <option key={tipoConsulta.id} value={tipoConsulta.id}>
                        {tipoConsulta.descricao}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
            )}
            <Col md={6}>
              <FormGroup>
                <Label for="valor">Valor</Label>
                <NumericFormat
                  value={valor}
                  thousandSeparator="."
                  decimalSeparator=","
                  prefix="R$ "
                  onValueChange={(values) => setValor(values.value)}
                  customInput={Input}
                />
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSubmit}>
          Marcar Consulta
        </Button>
        <Button color="secondary" onClick={toggle}>
          Cancelar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default NovaConsultaModal;
